import React, { FC, useEffect } from 'react';
import Routes from './routes';
import { toast, ToastContainer } from 'react-toastify';
import HeaderContainer from './components/layout/HeaderContainer';
import { useNavigate } from 'react-router-dom';
import { setNavigate } from './utils/navigationManager';

//@ts-ignore
if (navigator.deviceMemory < 8) {
  // eslint-disable-next-line prefer-const
  let body = document.body,
    timer: any;
  window.addEventListener(
    'scroll',
    function () {
      clearTimeout(timer);
      if (!body.classList.contains('disable-hover')) {
        body.classList.add('disable-hover');
      }
      timer = setTimeout(function () {
        body.classList.remove('disable-hover');
      }, 300);
    },
    true
  );
}

const App: FC = () => {
  const navigate = useNavigate(); // Отримуємо функцію navigate із хуку

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return (
    <>
      <HeaderContainer />
      <Routes />
      <ToastContainer position={toast.POSITION.TOP_CENTER} hideProgressBar />
    </>
  );
};

export default App;
